import { LoaderCircleIcon } from "lucide-react";
import { type ReactNode } from "react";

type Props = {
  loading?: boolean;
  size?: number;
  children?: ReactNode;
};

export function Spinner({ loading = true, size = 24, children }: Props) {
  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <LoaderCircleIcon size={size} className="animate-spin text-muted" />
      </div>
    );
  }

  return <>{children}</>;
}
